<template>
  <div
    class="d-flex w-100 position-relative"
    data-testid="elPasswordInput"
  >
    <input
      v-bind="$attrs"
      v-model="value"
      :class="css"
      class="pr-5 form-control"
      :type="type"
      autocomplete="off"
    >
    <button
      type="button"
      class="toggle-type"
      data-testid="toggle-show-password"
      @click="toggle"
      @keypress="toggle"
    >
      <elIcon :name="icon" />
    </button>
  </div>
</template>

<script>
import elIcon from './elIcon.vue'

export default {
  name: 'ElPasswordInput',
  components: {
    elIcon
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      type: 'password'
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    icon() {
      return this.type === 'password' ? 'eye' : 'eye-slash'
    }
  },
  methods: {
    toggle() {
      this.type = this.type === 'password' ? 'text' : 'password'
    }
  }
}
</script>

<style lang="scss" scoped>

  .toggle-type {
    position: absolute;
    top: 1px;
    right: 1px;
    display: flex;
    align-items: center;
    height: 94%;
    padding: 0 8px;
    background: transparent;
    border: none;
    border-radius: 1px;
    opacity: 0.4;
  }

  .toggle-type:focus,
  .toggle-type:hover {
    outline: none;
    opacity: 1;
  }

  .toggle-type:focus {
    background-color: #eee;
  }

</style>
